// The two fonts used across the app. Loaded in public/index.html (Google Fonts); index.css
// applies FONT_SANS to the page and Bootstrap, theme.js to every MUI component.
// Single quotes inside: the stacks are also used in inline style="..." HTML (map markers).

// Text everywhere: menus, grids, dialogs, pages
export const FONT_SANS = "'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, Arial, sans-serif";

// Numbers that should line up or not jitter: clocks, coordinates, counts, codes
export const FONT_MONO = "'Roboto Mono', ui-monospace, 'SFMono-Regular', Consolas, monospace";
